import { FullGestureState } from '@use-gesture/react';
import { MutableRefObject } from 'react';
import { Point } from '@/types';
import { assertDefined } from '@/utils/assertDefined';
import { subtractVectors } from '@/utils/math/subtractVectors';
import { getOwnerSVGElement } from './getOwnerSVGElement';

const transformPoint = (point: Point, element: SVGElement): Point => {
  const svg = assertDefined(getOwnerSVGElement(element));
  const matrix = assertDefined(svg.getScreenCTM()).inverse();
  const svgPoint = svg.createSVGPoint();
  svgPoint.x = point.x;
  svgPoint.y = point.y;

  return svgPoint.matrixTransform(matrix);
};

export const getDeltaFromState = (
  state: FullGestureState<'drag'>,
  ref: MutableRefObject<SVGElement | null>
) => {
  const svgElement = ref.current;
  if (svgElement) {
    const initial = transformPoint(
      {
        x: state.initial[0],
        y: state.initial[1],
      },
      svgElement
    );
    const current = transformPoint(
      {
        x: state.xy[0],
        y: state.xy[1],
      },
      svgElement
    );

    return subtractVectors(current, initial);
  }

  return { x: 0, y: 0 };
};
